@if (authService.hasPermission(Permission.OutputAssetsFull)) {
  <span
  [matTooltip]="
    selectedPostAssetIds.length === 0
      ? 'Select assets to create outputs'
      : 'Create Outputs'
  "
    >
    <button
      mat-icon-button
      class="apply-enhancement"
      (click)="onGenerate()"
      [disabled]="selectedPostAssetIds.length === 0"
      >
      <mat-icon>sync</mat-icon>
    </button>
  </span>
}
